import queryBuilder from '@glittr/frontend-core/src/plugins/validation/queryBuilder';

export default {
  ...queryBuilder.properties({
    safetyHookIds: {
      minItems: 1,
    },
  }),
};
